export default __webpack_public_path__ + "static/media/mandy.ea79885a.png";